export default __webpack_public_path__ + "static/media/teams_banner1.7380b555.png";